<button
  mat-mini-fab
  color="primary"
  class="add-button m-center"
  (click)="dropdown.toggle()"
  *mojoHasAnyPrivilege="[privileges.job.create, privileges.candidates.create, privileges.companies.create]"
  data-cy="header-add-item-toggle-popover-button"
>
  <mat-icon class="add-icon">add</mat-icon>
</button>
<mojo-dropdown
  #dropdown
  [closeWhenClickedInside]="true"
  [fullWidthOnMobile]="false"
>
  <ng-container>
    <a
      class="mojo-dropdown-menu-item"
      [routerLink]="['/jobs/form/create']"
      [skipLocationChange]="true"
      *mojoHasPrivilege="privileges.job.create"
      data-cy="header-open-new-add-job-modal-button"
    >
      Create a job
    </a>
  </ng-container>
  <ng-container>
    <a
      class="mojo-dropdown-menu-item"
      [routerLink]="['', { outlets: { modal: ['candidate-v2'] } }]"
      [skipLocationChange]="true"
      data-cy="header-open-new-add-candidate-modal-button"
      *mojoHasPrivilege="privileges.candidates.create"
    >
      Add candidate
    </a>
  </ng-container>
  <a
    class="mojo-dropdown-menu-item"
    [routerLink]="['/companies/form/create']"
    [skipLocationChange]="true"
    data-cy="header-open-add-company-modal-button"
    *mojoHasPrivilege="privileges.companies.create"
  >
    Add company
  </a>
</mojo-dropdown>
